import React from "react";
import Hero from "../elements/Hero";

function Header() {
  return (
    <header>
      <Hero />
    </header>
  );
}

export default Header;
